import { Injectable, isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CREDITAPP_API_URLS } from '../../global';
import { IValidateLeadResponse, IValidateLeadRequest } from '../interfaces/lead-validation.interface';


@Injectable({
  providedIn: 'root'
})
export class LeadFormService {

  constructor(
    private http: HttpClient
  ) { }

  private getScopedUrl(path: string, subPage: string): string {
    const scopedPath = subPage ? `/${subPage}${path}` : path;
    return isDevMode() ? `http://localhost:4000${scopedPath}` : scopedPath;
  }

  submitHLLead(params: any, subPage: string) {
    const url = this.getScopedUrl('/api/SubmitLead', subPage);
    return this.http.post(url, params)
  }

  async validateLead(request: IValidateLeadRequest, subPage: string): Promise<IValidateLeadResponse> {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), 10000);

    try {
      const response = await fetch(this.getScopedUrl(CREDITAPP_API_URLS.VALIDATE_LEAD, subPage), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request),
        signal: controller.signal
      });

      if (!response.ok) {
        throw new Error(`Lead validation failed with status ${response.status}`);
      }

      return await response.json() as IValidateLeadResponse;
    } catch (error) {
      console.error('Lead validation failed. Proceeding with lead submission.', error);
      return { ValidationId: 0, Result: '', Reasons: {} } as IValidateLeadResponse;
    } finally {
      window.clearTimeout(timeoutId);
    }
  }
}
